import type { king, Suit } from "@app/rules";
import { useT } from "../i18n/context";
import { kingGameText } from "../routes/kingText";
import { SUIT_GLYPH } from "./Card";

/** What the top bar says in place of a trump, for the games that have none of the usual kind. */

/** Hearts has no trump: the bar says whether hearts may be led yet. */
export function HeartsState({ open }: { open: boolean }) {
  const { t } = useT();
  return (
    <span className="flex items-center gap-1.5 py-0.5 pl-1.5 pr-3 text-[13px] text-ink/75">
      <span
        aria-hidden="true"
        className={`flex h-[26px] w-[26px] items-center justify-center rounded-[6px] bg-card text-[16px] leading-none text-card-red ${open ? "" : "opacity-45"}`}
      >
        {SUIT_GLYPH.hearts}
      </span>
      {t(open ? "hearts.bar.open" : "hearts.bar.closed")}
    </span>
  );
}

/** King: the game the chooser named for this hand; "?" while it is being named. */
export function KingGame({ view }: { view: king.KingView }) {
  const { t } = useT();
  const contract = view.contract;
  return (
    <span className="px-3 text-[13px] font-bold text-ink">
      {contract === null ? "?" : kingGameText(contract, t)}
    </span>
  );
}

/** The trump as a little white card; "?" before there is one. */
export function TrumpCard({ trump }: { trump: Suit | null }) {
  const { t } = useT();
  const red = trump === "hearts" || trump === "diamonds";
  const name = trump ? t("table.bar.trump", { suit: t(`suit.${trump}`) }) : t("table.bar.noTrump");
  return (
    <span
      className="flex items-center gap-1.5 py-0.5 pl-1.5 pr-3 text-[13px] text-ink/75"
      title={name}
    >
      <span
        aria-hidden="true"
        className={`flex h-[26px] w-[26px] items-center justify-center rounded-[6px] bg-card text-[16px] leading-none ${red ? "text-card-red" : "text-card-black"}`}
      >
        {trump ? SUIT_GLYPH[trump] : "?"}
      </span>
      {trump ? t("table.bar.trumpLabel") : t("table.bar.noTrump")}
    </span>
  );
}

/** Baloot's Sun has no trump suit: the bar names the mode instead. */
export function SunMode() {
  const { t } = useT();
  return (
    <span className="px-3 text-[13px] text-ink/75">
      {t("baloot.bar.mode")} <b className="text-ink">{t("baloot.call.sun")}</b>
    </span>
  );
}
